@use "foundation/colors";
@use "foundation/responsive";

$disabled-opacity: 0.4;

.button {
  color: #fff;
  cursor: pointer;
  display: block;
  font-size: 1.25em;
  font-weight: 700;
  padding: 1.5em;
  text-align: center;
  width: 100%;
}

.button:active,
.button:focus {
  opacity: .8;
}

.button:disabled {
  opacity: $disabled-opacity;
  cursor: default;
}

// Hide ugly dotted border in Firefox, since we're using opacity for focus
.button::-moz-focus-inner {
  border: 0;
}
